import type { ReactNode } from 'react';

/** Same reach-tier card chrome as `HowToReachTier` (gold → purple border). */
export const REACH_NEXT_TIER_BORDER_GRADIENT =
  'linear-gradient(0deg, #FBBF24 0%, #FABA28 7%, #F7AD37 14%, #F2984E 22%, #EB7B6F 31%, #E35599 39%, #D927CC 48%, #D821D4 49%, #BF18D6 54%, #A60FD9 60%, #9208DC 67%, #8403DD 74%, #7C00DE 84%, #7A00DF 100%)';

const AMBIENT_GRADIENT_SUB =
  'linear-gradient(150deg, transparent 0%, rgba(139,0,255,0) 18%, rgba(139,0,255,0.01) 32%, rgba(139,0,255,0.02) 43%, rgba(139,0,255,0.04) 54%, rgba(139,0,255,0.06) 64%, rgba(139,0,255,0.09) 74%, rgba(139,0,255,0.12) 83%, rgba(139,0,255,0.16) 92%, rgba(139,0,255,0.2) 100%)';

export function ReachTierDetailCard({
  children,
  borderGradient = REACH_NEXT_TIER_BORDER_GRADIENT,
  ambientGradient = AMBIENT_GRADIENT_SUB,
}: {
  children: ReactNode;
  borderGradient?: string;
  ambientGradient?: string;
}) {
  return (
    <div
      style={{
        width: '100%',
        marginTop: 4,
        padding: 2,
        borderRadius: 10,
        background: borderGradient,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          borderRadius: 8,
          background: '#0b0618',
          position: 'relative',
          overflow: 'hidden',
          padding: 12,
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: ambientGradient,
            pointerEvents: 'none',
          }}
        />
        <div style={{ position: 'relative', zIndex: 1 }}>{children}</div>
      </div>
    </div>
  );
}
